/* unplugin-vue-components disabled */import script from "./UserProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./UserProfile.vue?vue&type=script&setup=true&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=12c70d1b&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/pro-swan-h5-game/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c70d1b"]])

export default __exports__